/**
 * Recently Viewed Products — reads product handles from localStorage,
 * fetches their card HTML via Section Rendering API, populates the
 * glide slides, and triggers initialization by flipping data-disable.
 */
if (!customElements.get('p80-recently-viewed-products')) {
  customElements.define(
    'p80-recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      static STORAGE_KEY = 'p80RecentlyViewedProducts';

      connectedCallback() {
        this.limit = parseInt(this.dataset.limit, 10) || 10;
        this.currentHandle = (this.dataset.currentHandle || '').trim();
        this.sectionId = this.dataset.sectionId || 'p80-recently-viewed-card';
        this.loadedClass = this.dataset.loadedClass || 'recently-viewed-products--loaded';
        this.glide = this.querySelector('glide-component');
        this.slidesContainer = this.querySelector('[data-rv-slides]');
        this.loader = this.querySelector('[data-rv-loader]');

        if (!this.glide || !this.slidesContainer) return;
        this.load();
      }

      getHandles() {
        try {
          const raw = localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY);
          const parsed = raw ? JSON.parse(raw) : [];
          if (!Array.isArray(parsed)) return [];

          const handles = parsed
            .map((item) => (typeof item === 'string' ? item : item?.handle))
            .filter(Boolean);

          return handles.filter((h) => h !== this.currentHandle).slice(0, this.limit);
        } catch {
          return [];
        }
      }

      async load() {
        const handles = this.getHandles();

        if (handles.length === 0) {
          this.hide();
          this.markFetchComplete();
          return;
        }

        const results = await Promise.allSettled(handles.map((handle) => this.fetchCard(handle)));

        const cards = results
          .filter((r) => r.status === 'fulfilled' && r.value)
          .map((r) => r.value);

        if (cards.length === 0) {
          this.hide();
          this.markFetchComplete();
          return;
        }

        this.render(cards);
        this.markFetchComplete();
      }

      async fetchCard(handle) {
        const url = `/products/${handle}?section_id=${this.sectionId}`;
        const response = await fetch(url);
        if (!response.ok) return null;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.card-wrapper');
        return card ? card.outerHTML : null;
      }

      render(cards) {
        const slidesHtml = cards
          .map((html) => `<li class="slideshow__slide glide__slide">${html}</li>`)
          .join('');
        this.slidesContainer.innerHTML = slidesHtml;
        if (this.loader) this.loader.classList.remove('slideshow__loader--visible');
        this.glide.setAttribute('data-disable', 'false');
      }

      hide() {
        const section = this.closest('.shopify-section');
        if (section) section.style.display = 'none';
      }

      markFetchComplete() {
        this.classList.add(this.loadedClass);
      }
    }
  );
}
